import { ApolloError, useQuery } from '@apollo/client'

import { Country, GetCountrySettingsQuery, GetCountrySettingsQueryVariables } from '../../../types'
import { GET_COUNTRY_SETTINGS } from '../Queries'

export default function (country: Country): {
  data: GetCountrySettingsQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} {
  const variables = {
    country,
  }
  const { data, error, loading } = useQuery<GetCountrySettingsQuery, GetCountrySettingsQueryVariables>(GET_COUNTRY_SETTINGS, {
    variables: variables,
    fetchPolicy: 'network-only',
  })

  return { data, error, loading }
}
